import { ReactNode, SyntheticEvent } from 'react';
import cn from 'classnames';
import { UrlObject } from 'url';
import { TabLink as FrameworkTabLink } from '@framework/router/Next/Link';

import styles from './tabLink.module.scss';

interface ITabLinkProps {
  /** Destination URL */
  to: string | UrlObject,
  /** Tab label content */
  children?: ReactNode,
  /** Additional CSS class */
  className?: string,
  /** Matches the active state by exact path (incl. query) instead of by prefix */
  isExactActive?: boolean,
  /** Forces the active state regardless of the current path */
  isActive?: boolean,
  /** Disables the tab link */
  disabled?: boolean,
  /** Click handler */
  onClick?: (e: SyntheticEvent) => void,
  /** Test identifier */
  dataTest?: string,
}

const TabLink = ({
  to,
  children,
  className,
  isExactActive,
  isActive,
  disabled,
  onClick,
  dataTest = 'tabLink',
}: ITabLinkProps) => (
  <FrameworkTabLink
    to={ to }
    isActive={ isActive }
    isExactActive={ isExactActive }
    activeClassName={ styles.isActiveTabLink }
    disabled={ disabled }
    className={ cn(styles.tabLink, className, { [styles.isDisabledTabLink]: disabled }) }
    onClick={ onClick }
    dataTest={ dataTest }
  >
    { children }
  </FrameworkTabLink>
);

export default TabLink;
